var map = {
	"./1.svg": 5672,
	"./10.svg": 9591,
	"./11.svg": 2204,
	"./12.svg": 4381,
	"./13.svg": 696,
	"./14.svg": 6692,
	"./15.svg": 1552,
	"./16.svg": 6043,
	"./17.svg": 1084,
	"./18.svg": 9004,
	"./19.svg": 6324,
	"./2.svg": 1548,
	"./20.svg": 4416,
	"./21.svg": 2932,
	"./22.svg": 8924,
	"./23.svg": 5544,
	"./24.svg": 7903,
	"./25.svg": 868,
	"./26.svg": 796,
	"./27.svg": 8996,
	"./28.svg": 6820,
	"./29.svg": 2452,
	"./3.svg": 6424,
	"./30.svg": 4036,
	"./4.svg": 8680,
	"./5.svg": 9380,
	"./6.svg": 5408,
	"./7.svg": 1172,
	"./8.svg": 2756,
	"./9.svg": 4092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8152;